import React, { useState } from "react";
import { useMutation, useQuery } from "react-query";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import { Form, Input, Button, Select, Row, Col, Radio, Checkbox } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import RangePickerComp from "../../../../../components/common/RangePickerComp";
import SwitchComp from "../../../../../components/common/SwitchComp";
import axios from "axios";
import dayjs from "dayjs";
import { IconDraggableBig } from "../../../../../components/Layout/Icons";
import { ButtonDelete } from "../../../../../components/common/Buttons";
import UploadFormItem from "../UploadFormItem";
import { FaPlusCircle } from "react-icons/fa";
import moment from "moment";
import Treeselect from "../../../../../components/common/Treeselect";

const initialState = {
  id: null,
  urls: [""],
  urlContains: [false],
  excludeUrls: [""],
  check: false,
  desktopImageFile: null,
  desktopImageUrl: null,
  mobileImageFile: null,
  mobileImageUrl: null,
  destinationUrl: "",
  openInNewTab: false,
  selectedProducts: [],
  selectedInProducts: [],
  selectedCategories: [],
  originalCheckChange: false,
};

const fetchProducts = async (value) => {
  if (value?.length < 3) return [];
  const response = await axios.get(
    `/api/v1/products?page=1&per_page=100&q[identifier_eq]=${value}`
  );
  return response.data;
};

const fetchInProducts = async (value) => {
  if (value?.length < 3) return [];
  const response = await axios.get(
    `/api/v1/products?page=1&per_page=100&q[identifier_eq]=${value}`
  );
  return response.data;
};

const ModalNewPromotionPopups = ({
  onClose,
  modalOpt,
  orderShops,
  bigBoxCategory,
  bannerData,
}) => {
  const [form] = Form.useForm();
  const [switches, setSwitches] = React.useState({});
  const [search, setSearch] = React.useState("");
  const [searchInProducts, setSearchInProducts] = React.useState("");
  const [selectedValue, setSelectedValue] = React.useState("text");
  const [selectedShowPopupIn, setSelectedShowPopupIn] =
    React.useState("category");
  const options = ["category", "product", "url"];
  const [processedCategoryOptions, setProcessedCategoryOptions] = useState([]);

  const convertToTreeData = (treeData) => {
    if (!treeData || !Array.isArray(treeData)) return [];

    const modifyParentNodes = (node) => {
      if (node.children && node.children.length > 0) {
        const parentAsChild = {
          name: `${node.name}`,
          value: node.value,
          id: node.id,
          isParentCopy: true
        };

        const realId = node.value;
        node.value = `00_${realId}`;

        node.children.unshift(parentAsChild);

        for (let i = 1; i < node.children.length; i++) {
          modifyParentNodes(node.children[i]);
        }
      }

      return node;
    };

    return treeData.map(modifyParentNodes);
  };

  React.useEffect(() => {
    if (bigBoxCategory) {
      const processed = convertToTreeData(bigBoxCategory);
      setProcessedCategoryOptions(processed);
    }
  }, [bigBoxCategory]);

  console.log(switches, 'switches')
  const { data: productsData, isLoading } = useQuery(["products", search], () =>
    fetchProducts(search)
  );

  const {
    data: inProductsData,
    isLoading: inProductsIsLoading,
    refetch,
  } = useQuery(
    ["inProducts", searchInProducts],
    () => fetchInProducts(searchInProducts),
    {
      enabled: !!searchInProducts,
    }
  );
  const hasRun = React.useRef(false);

  React.useEffect(() => {
    if (!hasRun.current) {
      const initialSwitches = {};
      (orderShops || []).forEach((shop) => {
        initialSwitches[shop.label.replace(" ", "")] = {
          ...initialState,
          id: shop.value,
        };
      });
      setSwitches(initialSwitches);
      hasRun.current = true;
    }
  }, [orderShops]);

  const mutation = useMutation({
    mutationFn: (value) => {
      const formData = new FormData();
      formData.append("banner[title]", value.title);
      formData.append("banner[banner_place]", "promotion_popups");
      formData.append("banner[background_type]", selectedValue);
      formData.append("banner[valid_from]", value.validity_period[0]);
      formData.append("banner[valid_to]", value.validity_period[1]);
      formData.append("banner[popup_in]", selectedShowPopupIn);

      Object.entries(switches).forEach(([key, switchData], index) => {
        const desktopFile = switchData?.desktopImageFile;
        if (switchData.originalCheckChange) {
          if (switchData.selectedCategories.length > 0) {
            switchData.selectedCategories.forEach((categoryId) => {
              let id;
              if (typeof categoryId === "object" && categoryId !== null) {
                id = categoryId.id;
              } else {
                id = categoryId;
              }
              formData.append(
                `banner[banner_shops_attributes][${index}][categories][]`,
                id
              );
            });
          }

          if (switchData.selectedProducts.length > 0) {
            switchData.selectedProducts.forEach((product) => {
              formData.append(
                `banner[banner_shops_attributes][${index}][products][]`,
                product.id
              );
            });
          }
          if (switchData.selectedInProducts.length > 0) {
            switchData.selectedInProducts.forEach((product) => {
              const productId = typeof product === "object" && product !== null ? product.id : product;
              formData.append(
                `banner[banner_shops_attributes][${index}][products_page][]`,
                productId
              );
            });
          }
          if (switchData.urls.length > 0) {
            switchData.urls.forEach((url, idx) => {
              formData.append(
                `banner[banner_shops_attributes][${index}][destination_url][]`,
                url
              );
              formData.append(
                `banner[banner_shops_attributes][${index}][url_contains][]`,
                switchData.urlContains?.[idx] ? "true" : "false"
              );
            });
          }
          if (switchData.excludeUrls && switchData.excludeUrls.length > 0) {
            switchData.excludeUrls.forEach((url) => {
              formData.append(
                `banner[banner_shops_attributes][${index}][exclude_url][]`,
                url
              );
            });
          }
          if (switchData.destinationUrl || value[`redirect_url_${key}`]) {
            formData.append(
              `banner[banner_shops_attributes][${index}][redirect_url]`,
              value[`redirect_url_${key}`] || switchData.destinationUrl
            );
          }
          formData.append(
            `banner[banner_shops_attributes][${index}][open_in_new_tab]`,
            switchData.openInNewTab ? "true" : "false"
          );
          if (desktopFile) {
            formData.append(
              `banner[banner_shops_attributes][${index}][desktop_file][data]`,
              desktopFile
            );
            formData.append(
              `banner[banner_shops_attributes][${index}][desktop_file][title]`,
              desktopFile.name
            );
          }

          formData.append(
            `banner[banner_shops_attributes][${index}][active]`,
            switchData.check ? "true" : "false"
          );
          formData.append(
            `banner[banner_shops_attributes][${index}][order_shop_id]`,
            switchData.id
          );
          if (modalOpt.type === "edit_promotion_popups") {
            if (switchData.banner_shop_id) {
              formData.append(
                `banner[banner_shops_attributes][${index}][id]`,
                switchData.banner_shop_id
              );
            }
          }
        }
        if (value[`delay_time_${key}`]) {
          formData.append(
            `banner[banner_shops_attributes][${index}][delay_time]`,
            value[`delay_time_${key}`]
          );
        }

        if (value[`sleep_time_${key}`]) {
          formData.append(
            `banner[banner_shops_attributes][${index}][sleep_time]`,
            value[`sleep_time_${key}`]
          );
        }
      });

      return Axios[modalOpt.type === "edit_promotion_popups" ? "put" : "post"](
        `/api/v1/banners/${modalOpt.type === "edit_promotion_popups" ? modalOpt.record_id : ""
        }`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      ).then((res) => res.data);
    },
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const handleSwitchChange = (name) => {
    setSwitches((prev) => {
      const updatedCheck = !prev[name].check;
      return {
        ...prev,
        [name]: {
          ...prev[name],
          check: updatedCheck,
          originalCheckChange: prev[name].originalCheck !== updatedCheck,
        },
      };
    });
  };

  const handleCategoryChange = (switchName, value) => {
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        selectedCategories: value,
        originalCheckChange: true,
      },
    }));
  };

  const handleProductChange = (switchName, value) => {
    const product = productsData?.data?.find((product) => product.id === value);
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        selectedProducts: [
          ...prev[switchName].selectedProducts,
          { id: product.id, label: product.title, identifier: product.identifier || '' },
        ],
        originalCheckChange: true,
      },
    }));
  };

  const handleInProductChange = (switchName, value) => {
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        selectedInProducts: [...prev[switchName].selectedInProducts, ...value],
        originalCheckChange: true,
      },
    }));
  };

  const handleDelete = (switchName, id) => {
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        selectedProducts: prev[switchName].selectedProducts.filter(
          (product) => product.id !== id
        ),
        originalCheckChange: true,
      },
    }));
  };

  const handleFileChange = (name, type, file, url) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [`${type}ImageFile`]: file,
        [`${type}ImageUrl`]: url,
        [`${type}Image`]: file,
        [`${type}ImageFileTitle`]: file?.name,
      },
    }));
  };

  const handleAddClick = (switchName) => {
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        urls: [...prev[switchName].urls, ""],
        urlContains: [...prev[switchName].urlContains, false],
      },
    }));
  };
  const handleUrlChange = (switchName, index, event) => {
    const { value } = event.target;

    setSwitches((prev) => {
      const newList = [...prev[switchName].urls];
      newList[index] = value;
      return {
        ...prev,
        [switchName]: {
          ...prev[switchName],
          urls: newList,
        },
      };
    });
  };

  const handleAddExcludeClick = (switchName) => {
    setSwitches((prev) => ({
      ...prev,
      [switchName]: {
        ...prev[switchName],
        excludeUrls: [...prev[switchName].excludeUrls, ""],
      },
    }));
  };

  const handleExcludeUrlChange = (switchName, index, event) => {
    const { value } = event.target;

    setSwitches((prev) => {
      const newList = [...prev[switchName].excludeUrls];
      newList[index] = value;
      return {
        ...prev,
        [switchName]: {
          ...prev[switchName],
          excludeUrls: newList,
        },
      };
    });
  };

  const onDragEnd = (result) => {
    const { destination, source } = result;

    if (!destination) {
      return;
    }

    const sourceSwitchName = source.droppableId;
    const destinationSwitchName = destination.droppableId;

    if (sourceSwitchName === destinationSwitchName) {
      const newSelectedProducts = Array.from(
        switches[sourceSwitchName].selectedProducts
      );
      const [removed] = newSelectedProducts.splice(source.index, 1);
      newSelectedProducts.splice(destination.index, 0, removed);

      setSwitches((prev) => ({
        ...prev,
        [sourceSwitchName]: {
          ...prev[sourceSwitchName],
          selectedProducts: newSelectedProducts,
          originalCheckChange: true,
        },
      }));
    } else {
      const sourceSelectedProducts = Array.from(
        switches[sourceSwitchName].selectedProducts
      );
      const destinationSelectedProducts = Array.from(
        switches[destinationSwitchName].selectedProducts
      );
      const [removed] = sourceSelectedProducts.splice(source.index, 1);
      destinationSelectedProducts.splice(destination.index, 0, removed);

      setSwitches((prev) => ({
        ...prev,
        [sourceSwitchName]: {
          ...prev[sourceSwitchName],
          selectedProducts: sourceSelectedProducts,
          originalCheckChange: true,
        },
        [destinationSwitchName]: {
          ...prev[destinationSwitchName],
          selectedProducts: destinationSelectedProducts,
          originalCheckChange: true,
        },
      }));
    }
  };

  React.useEffect(() => {
    if (modalOpt.type === "edit_promotion_popups") {
      const matchingBanner = bannerData?.find(
        (banner) => banner.id === modalOpt.record_id
      );
      if (matchingBanner) {
        let formValues = {
          title: matchingBanner.title,
          validity_period: [
            moment(matchingBanner.valid_from),
            moment(matchingBanner.valid_to),
          ],
        };

        setSelectedShowPopupIn(matchingBanner.popup_in);
        setSelectedValue(matchingBanner.background_type);

        matchingBanner.banner_shops.forEach((shop) => {
          const switchName = shop.order_shop.title?.replace(" ", "");

          formValues[`delay_time_${switchName}`] = shop.delay_time;
          formValues[`sleep_time_${switchName}`] = shop.sleep_time;
          formValues[`redirect_url_${switchName}`] = shop.redirect_url || "";
          formValues[`open_in_new_tab_${switchName}`] = shop.open_in_new_tab || false;

          setSwitches((prev) => {
            if (prev[switchName]) {
              return {
                ...prev,
                [switchName]: {
                  ...prev[switchName],
                  desktopImageUrl: shop.desktop_image,
                  mobileImageUrl: shop.mobile_image,
                  urls: Array.isArray(shop.destination_url) ? shop.destination_url : [""],
                  urlContains: Array.isArray(shop.url_contains)
                    ? shop.url_contains
                    : new Array(Array.isArray(shop.destination_url) ? shop.destination_url.length : 1).fill(!!shop.url_contains),
                  excludeUrls: Array.isArray(shop.exclude_url) ? shop.exclude_url : [""],
                  destinationUrl: shop.redirect_url || "",
                  openInNewTab: shop.open_in_new_tab || false,
                  delay_time: shop.delay_time,
                  sleep_time: shop.sleep_time,
                  selectedCategories: (shop.categories || []).map((category) => ({
                    id: category.id,
                    label: category.name,
                  })),
                  check: shop.active,
                  originalCheck: shop.active,
                  banner_shop_id: shop.id,
                  originalCheckChange: true,
                  selectedProducts: (shop.products || []).map((product) => ({
                    id: product.id,
                    label: product.title,
                    identifier: product.identifier || '',
                  })),
                  selectedInProducts: (shop.products_page || []).map((product) => ({
                    id: product.id,
                    label: product.title,
                  })),
                },
              };
            } else {
              return prev;
            }
          });
        });

        form.setFieldsValue(formValues);
      }
    }
  }, [modalOpt, form, bannerData]);


  return (
    <ModalSpecial
      style={{ width: 570 }}
      text={
        <span className="font-bold text-xl text-black">
          {modalOpt.type === "edit_promotion_popups" ? "Edit" : "Add"} promotion
          popup
        </span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={(value) => {
          mutation.mutate(value);
        }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <Input placeholder="Type in" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Type" name="banner_types">
              <Row gutter={16}>
                <Col span={12}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      marginBottom: 16,
                      height: 32,
                      borderColor: selectedValue === "text" ? "#03B0F7" : "",
                      backgroundColor:
                        selectedValue === "text" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("text")}
                  >
                    <Radio
                      className={
                        selectedValue === "text" ? "selected-radio" : ""
                      }
                      style={{
                        color: selectedValue === "text" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "text"}
                      value="text"
                    >
                      Product
                    </Radio>
                  </div>
                </Col>
                <Col span={12}>
                  <div
                    className="card-type ant-input cursor-pointer"
                    style={{
                      marginBottom: 16,
                      height: 32,
                      borderColor: selectedValue === "image" ? "#03B0F7" : "",
                      backgroundColor:
                        selectedValue === "image" ? "#EDF9FE" : "",
                    }}
                    onClick={() => setSelectedValue("image")}
                  >
                    <Radio
                      className={
                        selectedValue === "image" ? "selected-radio" : ""
                      }
                      style={{
                        color: selectedValue === "image" ? "#03B0F7" : "",
                      }}
                      checked={selectedValue === "image"}
                      value="image"
                    >
                      Image
                    </Radio>
                  </div>
                </Col>
              </Row>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Show popup in" name="show_popup_in">
          <Row gutter={16}>
            {options.map((option) => (
              <ShowPopupInOption
                key={option}
                value={option}
                selectedShowPopupIn={selectedShowPopupIn}
                setSelectedShowPopupIn={setSelectedShowPopupIn}
              />
            ))}
          </Row>
        </Form.Item>
        <Form.Item
          label="Validity period"
          name="validity_period"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <RangePickerComp
            style={{ width: "100%" }}
            showTime={{ format: "HH:mm" }}
            placeholder={["Start time", "End time"]}
            disabledDate={() => false}
          />
        </Form.Item>
        <hr className="hr-margin" />
        {Object.keys(switches).map((switchName) => (
          <div key={switchName}>
            <SwitchComp
              className="d-flex flex-row-reverse justify-content-end"
              labelClassName="ml-1"
              label={switchName.slice(0, 2) + " " + switchName.slice(2)}
              checked={switches[switchName].check}
              onChange={() => handleSwitchChange(switchName)}
            />
            {switches[switchName].check && (
              <>
                {selectedValue === "text" ? (
                  <div>
                    <p
                      style={{
                        marginTop: 5,
                        marginBottom: 5,
                        color: "#212121",
                        fontWeight: "500",
                        fontSize: 13,
                      }}
                    >
                      Show these
                    </p>
                    <div className="drag-and-drop-select-container">
                      <Form.Item
                        label="Add product"
                        name={`show_product_${switchName}`}
                        rules={[
                          { required: false, message: "Can't be empty" },
                          () => ({
                            validator(_, value) {
                              if (
                                switches?.[switchName]?.selectedProducts
                                  ?.length === 0
                              ) {
                                return Promise.reject(
                                  new Error(
                                    "At least one product must be added"
                                  )
                                );
                              }
                              return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Select
                          showSearch
                          placeholder="Select a product"
                          optionFilterProp="children"
                          onSearch={setSearch}
                          loading={isLoading}
                          onChange={(value) =>
                            handleProductChange(switchName, value)
                          }
                        >
                          {productsData?.data?.map?.((product) => (
                            <Select.Option key={product.id} value={product.id}>
                              {product.identifier} - {product.title}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                      {switches?.[switchName]?.selectedProducts?.length ===
                        0 && (
                          <div className="text-sm text-gray-500">
                            No products added
                          </div>
                        )}
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId={switchName}>
                          {(provided) => (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {switches?.[switchName]?.selectedProducts?.map?.(
                                (product, index) => (
                                  <Draggable
                                    key={product.id.toString()}
                                    draggableId={product.id.toString()}
                                    index={index}
                                  >
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div
                                          className="d-flex align-items-center justify-content-between bg-white p-1 mb-1"
                                          style={{
                                            border: "1px solid #E9E9E9",
                                            borderRadius: 2,
                                            backgroundColor: "#FCFCFC",
                                          }}
                                        >
                                          <div className="d-flex align-items-center">
                                            <div className="mr-1">
                                              <IconDraggableBig />
                                            </div>
                                            <div className="ml-1 text-sm text-black">
                                              {product.label}
                                            </div>
                                          </div>
                                          <ButtonDelete
                                            onDelete={() =>
                                              handleDelete(
                                                switchName,
                                                product.id
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                )
                              )}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
                ) : (
                  <div>
                    <UploadFormItem
                      name={switchName}
                      label="Show image"
                      requiredMessage="Please upload an image!"
                      greyText="Recommended .jpeg, .png format and 1200x644"
                      onFileChange={(file, url) =>
                        handleFileChange(switchName, "desktop", file, url)
                      }
                      externalURL={switches[switchName].desktopImageUrl}
                    />
                  </div>
                )}
                {selectedShowPopupIn === "url" && (
                  <>
                    <p className="mb-1 mt-1">In URL</p>
                    {switches?.[switchName]?.urls?.map?.((url, index) => (
                      <Form.Item
                        key={index}
                        name={`url_${index}`}
                        rules={[{ required: false, message: "Can't be empty" }]}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: 5,
                          }}
                          key={index}
                        >
                          <input
                            className="ant-input cursor-pointer"
                            placeholder="Type in"
                            value={switches?.[switchName]?.urls?.[index] || ""}
                            onChange={(e) =>
                              handleUrlChange(switchName, index, e)
                            }
                            style={{ flex: 1 }}
                          />
                          <Checkbox
                            checked={switches?.[switchName]?.urlContains?.[index] || false}
                            onChange={(e) => {
                              setSwitches((prev) => {
                                const prevContains = Array.isArray(prev[switchName].urlContains) ? prev[switchName].urlContains : [];
                                const newContains = [...prevContains];
                                newContains[index] = e.target.checked;
                                return {
                                  ...prev,
                                  [switchName]: {
                                    ...prev[switchName],
                                    urlContains: newContains,
                                  },
                                };
                              });
                            }}
                            style={{ marginLeft: 8, whiteSpace: 'nowrap' }}
                          >
                            Contains
                          </Checkbox>

                          {index > 0 && (
                            <ButtonDelete
                              onDelete={() => {
                                setSwitches((prev) => {
                                  const newList = [
                                    ...prev[switchName].urls.filter(
                                      (_, i) => i !== index
                                    ),
                                  ];
                                  const newContains = [
                                    ...prev[switchName].urlContains.filter(
                                      (_, i) => i !== index
                                    ),
                                  ];
                                  return {
                                    ...prev,
                                    [switchName]: {
                                      ...prev[switchName],
                                      urls: newList,
                                      urlContains: newContains,
                                    },
                                  };
                                });
                              }}
                            />
                          )}
                        </div>
                      </Form.Item>
                    ))}
                    <div
                      style={{
                        marginBottom: 5,
                        marginTop: 5,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleAddClick(switchName)}
                    >
                      <FaPlusCircle color="#03B0F7" />
                      <p
                        style={{
                          color: "#03B0F7",
                          marginLeft: 5,
                          marginBottom: 0,
                          marginTop: 0,
                        }}
                      >
                        Add additional
                      </p>
                    </div>

                    <p className="mb-1 mt-3">Exclude URL</p>
                    {switches?.[switchName]?.excludeUrls?.map?.((url, index) => (
                      <Form.Item
                        key={index}
                        name={`exclude_url_${index}`}
                        rules={[{ required: false, message: "Can't be empty" }]}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            marginBottom: 5,
                          }}
                          key={index}
                        >
                          <input
                            className="ant-input cursor-pointer"
                            placeholder="Type in URL to exclude"
                            value={switches?.[switchName]?.excludeUrls?.[index] || ""}
                            onChange={(e) =>
                              handleExcludeUrlChange(switchName, index, e)
                            }
                          />

                          {index > 0 && (
                            <ButtonDelete
                              onDelete={() => {
                                setSwitches((prev) => {
                                  const newList = [
                                    ...prev[switchName].excludeUrls.filter(
                                      (_, i) => i !== index
                                    ),
                                  ];
                                  return {
                                    ...prev,
                                    [switchName]: {
                                      ...prev[switchName],
                                      excludeUrls: newList,
                                    },
                                  };
                                });
                              }}
                            />
                          )}
                        </div>
                      </Form.Item>
                    ))}
                    <div
                      style={{
                        marginBottom: 5,
                        marginTop: 5,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleAddExcludeClick(switchName)}
                    >
                      <FaPlusCircle color="#03B0F7" />
                      <p
                        style={{
                          color: "#03B0F7",
                          marginLeft: 5,
                          marginBottom: 0,
                          marginTop: 0,
                        }}
                      >
                        Add additional exclude URL
                      </p>
                    </div>
                  </>
                )}
                {selectedShowPopupIn === "category" && (
                  <>
                    <p
                      style={{
                        marginTop: 5,
                        marginBottom: 5,
                        color: "#212121",
                        fontWeight: "500",
                        fontSize: 13,
                      }}
                    >
                      In these
                    </p>
                    <div className="drag-and-drop-select-container">
                      <Form.Item
                        label="Category"
                        name={`category_${switchName}`}
                        rules={[{ required: true, message: "Can't be empty" }]}
                        initialValue={switches[
                          switchName
                        ].selectedCategories.map((category) => category.id)}
                      >
                        <Treeselect
                          options={processedCategoryOptions || []}
                          value={switches[switchName].selectedCategories.map(category =>
                            typeof category === 'object' ? category.id : category
                          )}
                          onChange={(values) => {
                            const categoryIds = values.map(value => {
                              return typeof value === 'string' && value.startsWith('00_')
                                ? parseInt(value.substring(3))
                                : value;
                            });

                            const formattedCategories = categoryIds.map(id => {
                              const findCategory = (categories, targetId) => {
                                for (const cat of categories || []) {
                                  if (cat.id === targetId) return cat;
                                  if (cat.children) {
                                    const found = findCategory(cat.children, targetId);
                                    if (found) return found;
                                  }
                                }
                                return null;
                              };

                              const category = findCategory(bigBoxCategory, id);
                              return {
                                id: id,
                                label: category?.name || `Category ${id}`
                              };
                            });

                            handleCategoryChange(switchName, formattedCategories);
                          }}
                          placeholder="Select categories..."
                          multiSelect={true}
                          searchable={true}
                          confirmClear={true}
                          dropdownWidth="500px"
                          showStrategy="SHOW_ALL"
                        />
                      </Form.Item>
                    </div>
                  </>
                )}
                {selectedShowPopupIn === "product" && (
                  <>
                    <p
                      style={{
                        marginTop: 5,
                        marginBottom: 5,
                        color: "#212121",
                        fontWeight: "500",
                        fontSize: 13,
                      }}
                    >
                      In these
                    </p>
                    <div className="drag-and-drop-select-container">
                      <Form.Item
                        label="Products"
                        name={`products_${switchName}`}
                        rules={[{ required: true, message: "Can't be empty" }]}
                        initialValue={switches[
                          switchName
                        ].selectedInProducts.map((product) => ({
                          value: product.id,
                          label: product.label,
                        }))}
                      >
                        <Select
                          mode="multiple"
                          optionFilterProp="children"
                          placeholder="Select a product"
                          loading={inProductsIsLoading}
                          onSearch={setSearchInProducts}
                          onChange={(value) =>
                            handleInProductChange(switchName, value)
                          }
                        >
                          {inProductsData?.data?.map?.((product) => (
                            <Select.Option key={product.id} value={product.id}>
                              {product.identifier} - {product.title}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </>
                )}
                <Form.Item
                  label="Delay period"
                  name={`delay_time_${switchName}`}
                  rules={[{ required: true, message: "Can't be empty" }]}
                >
                  <Input type="number" suffix="seconds" />
                </Form.Item>
                <Form.Item
                  label="Sleep period"
                  name={`sleep_time_${switchName}`}
                  rules={[{ required: true, message: "Can't be empty" }]}
                >
                  <Input type="number" suffix="minutes" />
                </Form.Item>
                <Form.Item
                  label="Redirect URL"
                  name={`redirect_url_${switchName}`}
                >
                  <Input
                    placeholder="https://example.com/page"
                  />
                </Form.Item>
                <Form.Item
                  name={`open_in_new_tab_${switchName}`}
                  valuePropName="checked"
                >
                  <Checkbox
                    checked={switches[switchName].openInNewTab}
                    onChange={(e) => {
                      setSwitches((prev) => ({
                        ...prev,
                        [switchName]: {
                          ...prev[switchName],
                          openInNewTab: e.target.checked,
                          originalCheckChange: true,
                        },
                      }));
                    }}
                  >
                    Open in new tab
                  </Checkbox>
                </Form.Item>
              </>
            )}

            <hr className="hr-margin" />
          </div>
        ))}
        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={mutation.isLoading}
          >
            {modalOpt.type === "edit_promotion_popups" ? "Update" : "Add"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

const ShowPopupInOption = ({
  value,
  selectedShowPopupIn,
  setSelectedShowPopupIn,
}) => (
  <Col span={8}>
    <div
      className="card-type ant-input cursor-pointer"
      style={{
        marginBottom: 16,
        height: 32,
        borderColor: selectedShowPopupIn === value ? "#03B0F7" : "",
        backgroundColor: selectedShowPopupIn === value ? "#EDF9FE" : "",
      }}
      onClick={() => setSelectedShowPopupIn(value)}
    >
      <Radio
        className={selectedShowPopupIn === value ? "selected-radio" : ""}
        style={{
          color: selectedShowPopupIn === value ? "#03B0F7" : "",
        }}
        onClick={() => setSelectedShowPopupIn(value)}
        checked={selectedShowPopupIn === value}
        value={value}
      >
        {value.charAt(0).toUpperCase() + value.slice(1)}
      </Radio>
    </div>
  </Col>
);
export default ModalNewPromotionPopups;
